export default __webpack_public_path__ + "static/media/251.211d33b7.png";